import { RichTextAdvancedSchema } from '@framework/engine/inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { BaseLayoutSchema } from '@framework/engine/schema/widgets/repository/common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { yup } from '@framework/validation/initYup.ts';
import {
  type IEmailVerificationWidget,
  WidgetEmailVerificationType,
} from './IEmailVerificationWidget.ts';

export const EmailVerificationWidgetConfigSchema: yup.ObjectSchema<IEmailVerificationWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetEmailVerificationType)
      .label('Tipo'),
    layout: BaseLayoutSchema.shape({
      startButtonText: yup
        .string()
        .optional()
        .default('Verifica Email')
        .label('Testo pulsante iniziale'),
      startHelpText: RichTextAdvancedSchema.optional().label(
        'Testo di aiuto iniziale',
      ),
      endButtonText: yup
        .string()
        .optional()
        .default('Conferma Ricezione')
        .label('Testo pulsante verifica'),
      endHelpText: RichTextAdvancedSchema.optional().label(
        'Testo di aiuto verifica',
      ),
    }),
  })
    .required()
    .noUnknown();
